import { lazyLoad } from "../../../utils/loadable";

export const DealSpotlightsPage = lazyLoad(
  () => import("./index"),
  (module) => module.default,
);
